import { render, staticRenderFns } from "./AddChatTemplateForm.vue?vue&type=template&id=41d6e8d3&scoped=true"
import script from "./AddChatTemplateForm.vue?vue&type=script&lang=js"
export * from "./AddChatTemplateForm.vue?vue&type=script&lang=js"
import style0 from "./AddChatTemplateForm.vue?vue&type=style&index=0&id=41d6e8d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d6e8d3",
  null
  
)

export default component.exports